const keys = {
  all: ['pinsAdminUsers'],
  search: term => [...keys.all, 'search', { term }]
};

export default keys;
